import React from "react";
import { graphql, useFragment } from "react-relay";
import { TeamScheduleListItemWeeklyRange } from "./TeamScheduleListItemWeeklyRange";
import { TeamScheduleListItemMonthlyRange } from "./TeamScheduleListItemMonthlyRange";
import { TeamScheduleListItemScheduleRange_routineOccasion$key } from "./__generated__/TeamScheduleListItemScheduleRange_routineOccasion.graphql";

export function TeamScheduleListItemScheduleRange(props: {
  routineOccasion: TeamScheduleListItemScheduleRange_routineOccasion$key;
  itemType: "timeOfDay" | "allDay" | "WEEKLY" | "MONTHLY";
}) {
  const routineOccasion = useFragment(
    graphql`
      fragment TeamScheduleListItemScheduleRange_routineOccasion on ScheduledOccasion {
        ...TeamScheduleListItemWeeklyRange_routineOccasion
        ...TeamScheduleListItemMonthlyRange_routineOccasion
      }
    `,
    props.routineOccasion
  );
  return (
    <>
      {props.itemType === "WEEKLY" ? (
        <TeamScheduleListItemWeeklyRange routineOccasion={routineOccasion} />
      ) : null}
      {props.itemType === "MONTHLY" ? (
        <TeamScheduleListItemMonthlyRange routineOccasion={routineOccasion} />
      ) : null}
    </>
  );
}
